export default {"theme":{"dark":false,"themes":{"light":{"primary":"#1565c0","accent":"#d84315","secondary":"#0d47a1","info":"#e3f2fd","warning":"#ffc107","error":"#dd2c00","success":"#00e676"}}}}
